import qs from "qs";

import { UrlProvider } from "../api/UrlProvider";
import {
  AUTOMATIC_STRATEGY_LOCKED_SEARCH_FIELDS,
  getAutomaticStrategyTableSearch
} from "./automaticStrategySignalsNavigation";
import { LOCKED_SETTINGS_QUERY_KEY } from "./UniversalTable/lockedSettings";

export function buildLegacyTurtleStrategyRedirectHref({
  locale,
  query = {}
} = {}) {
  const path = UrlProvider.getLocalizedUrl(
    locale,
    "fe.trendDashboardSignalsTab",
    { locale }
  );
  const search = getAutomaticStrategyTableSearch({
    ticker: query.search?.ticker,
    market: query.search?.market
  });

  if (!search) {
    return path;
  }

  return `${path}?${qs.stringify({
    search,
    [LOCKED_SETTINGS_QUERY_KEY]: AUTOMATIC_STRATEGY_LOCKED_SEARCH_FIELDS
  })}`;
}
